import { segment, identify, track } from '@mc/track-event'
import request, {
  params,
  isSuccessful,
  needsConfirmation,
  getError,
} from './authApiService'

const auth = () => {
  const urlParams = new URLSearchParams(document.location.search)
  const nextPage = urlParams.get('next_page') || ''
  return request(
    '/auth/facebook/callback',
    params({
      next_page: nextPage,
    }),
  )
    .then((res) => {
      if (isSuccessful(res)) {
        const { email, userId, newUser } = res
        identify(userId, { email })

        if (newUser) {
          track(segment.EventTypes.ACCOUNT_CREATED, {
            email,
            userId,
            location: 'sign up modal',
          })
        }
        return res
      }
      if (needsConfirmation(res)) {
        return res
      }
      throw getError()
    })
    .catch((e) => {
      throw e
    })
}

export default auth
